import React from 'react';
import { View, Image, StyleSheet, ImageBackground } from 'react-native';
import { CommonStyles, CommonProperties, Color, FontSize } from '../../styles';
import { Screens, Modals } from '../../constants/ScreenNames';
import { useNavigation } from '@react-navigation/native';
import { scale } from '../../utils/scale.utils';
import RowView from '../RowView';
import BaseText from '../BaseText';
import Button from '../Button';

const InvitationAlert = ({ trip, type }) => {
  const navigation = useNavigation();
  return (
    <View style={[styles.mainContainer, CommonStyles.boxShadow]}>
      <RowView style={styles.container}>
        <Image source={{ uri: 'https://picsum.photos/80' }} style={styles.smallImage} />
        <View style={styles.cardHeading}>
          <BaseText style={styles.mediumText}>Martha S.</BaseText>
          <BaseText style={CommonStyles.h4}>Approved your trip.</BaseText>
        </View>
        <BaseText style={styles.mediumText}>2h</BaseText>
      </RowView>
      <View style={styles.cardBody}>
        <ImageBackground source={{ uri: 'https://picsum.photos/300' }} style={styles.cardImage}>
          <View style={styles.cardContent}>
            <BaseText style={styles.cardMessage}>
              {type == 'Savings' && 'Savings Found $43'}
              {type == 'Invitation' && 'You have been invited'}
            </BaseText>
          </View>
        </ImageBackground>
      </View>
      <View style={styles.acceptedContainer}>
        <RowView style={styles.acceptedContent}>
          <View>
            <Image source={{ uri: 'https://picsum.photos/100' }} style={styles.acceptedImage} />
          </View>
          <View style={styles.bottomSection}>
            <BaseText style={styles.mediumText}>Steve A.</BaseText>
            <BaseText style={styles.mediumText}>Miami, FL</BaseText>
          </View>
          <View style={styles.bottomSection}>
            {type == 'Savings' && <BaseText style={CommonStyles.h4}>$546</BaseText>}
            <BaseText style={styles.mediumText}>TripName Jun12 - Jun14</BaseText>
          </View>
        </RowView>
        <Button
          label={'View ' + type}
          style={styles.acceptedButton}
          labelStyle={styles.labeltext}
          onPress={() => {
            navigation.navigate(Modals.InvitationModal);
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    ...CommonStyles.mt3,
  },
  container: {
    justifyContent: 'space-between',
    ...CommonProperties.p3,
    borderTopLeftRadius: scale(6),
    borderTopRightRadius: scale(6),
  },
  smallImage: {
    height: 44,
    width: 44,
    borderRadius: 22,
  },
  mediumText: {
    color: Color.text.medium,
  },
  cardHeading: {
    flex: 1,
    ...CommonProperties.pl3,
  },
  cardBody: { flex: 1 },
  cardImage: {
    height: 150,
    width: '100%',
    resizeMode: 'contain',
    position: 'relative',
  },
  acceptedContainer: {
    borderBottomLeftRadius: scale(6),
    borderBottomRightRadius: scale(6),
    ...CommonProperties.px3,
    ...CommonProperties.pb3,
  },
  cardContent: {
    fontWeight: 'bold',
    opacity: 0.7,
    width: '80%',
    height: '20%',
    borderRadius: 15,
    position: 'absolute',
    bottom: '40%',
    left: '10%',
    alignContent: 'center',
    backgroundColor: Color.accent,
  },
  cardMessage: {
    textAlign: 'center',
    fontSize: FontSize.h2,
  },
  bottomSection: {
    alignItems: 'flex-end',
    ...CommonProperties.pt2,
  },
  acceptedImage: {
    height: 60,
    width: 60,
    borderRadius: 30,
    position: 'absolute',
    marginTop: -15,
    borderColor: 'white',
    borderWidth: 3,
  },
  acceptedContent: {
    justifyContent: 'space-between',
    ...CommonProperties.pt2,
    ...CommonProperties.pb3,
  },
  acceptedButton: {
    ...CommonProperties.borderRadius4,
    ...CommonProperties.py2,
  },
  labeltext: {
    ...CommonProperties.h3,
  },
});

export default InvitationAlert;
